import { NavLink, Outlet, useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import UserInfo from './UserInfo'
import ColorMode from './ColorMode'
import Fullscreen from './Fullscreen'
import { exitFullscreenSafe, forceLogout } from '../services/auth/session'

const LayoutMechanic = ({ user, setUser }) => {
  const navigate = useNavigate()

  useEffect(() => {
    const requestFullscreenSafe = () => {
      const el = document.documentElement
      const isFullscreen =
        !!document.fullscreenElement ||
        !!document.webkitFullscreenElement ||
        !!document.mozFullScreenElement ||
        !!document.msFullscreenElement

      if (isFullscreen || !el?.requestFullscreen) return
      el.requestFullscreen().catch(() => {
        // Some browsers require explicit user gesture.
      })
    }

    // Try immediately (works in some contexts, e.g. kiosk/PWA).
    requestFullscreenSafe()

    // Fallback: first user interaction.
    const handleFirstInteraction = event => {
      // The dedicated toggle must be the only fullscreen handler for its click.
      if (event.target instanceof Element && event.target.closest('[data-fullscreen-toggle]')) {
        window.removeEventListener('pointerdown', handleFirstInteraction)
        window.removeEventListener('keydown', handleFirstInteraction)
        window.removeEventListener('touchstart', handleFirstInteraction)
        return
      }

      requestFullscreenSafe()
      window.removeEventListener('pointerdown', handleFirstInteraction)
      window.removeEventListener('keydown', handleFirstInteraction)
      window.removeEventListener('touchstart', handleFirstInteraction)
    }

    window.addEventListener('pointerdown', handleFirstInteraction, { passive: true })
    window.addEventListener('keydown', handleFirstInteraction)
    window.addEventListener('touchstart', handleFirstInteraction, { passive: true })

    return () => {
      window.removeEventListener('pointerdown', handleFirstInteraction)
      window.removeEventListener('keydown', handleFirstInteraction)
      window.removeEventListener('touchstart', handleFirstInteraction)
      exitFullscreenSafe()
    }
  }, [])

  const handleLogout = async () => {
    await forceLogout({ redirect: false })
    if (typeof setUser === 'function') setUser(null)
    navigate('/login', { replace: true })
  }

  return (
    <div className="mechanic-shell">
      <header className="mechanic-topbar">
        <div className="mechanic-primary-nav" aria-label="Hlavní navigace mechanika">
          <NavLink to="/dashboard" className={({ isActive }) => `btn btn-lg ${isActive ? 'btn-primary' : 'btn-outline-primary'}`}>
            <i className="bi bi-wrench-adjustable me-2"></i>
            <span>Zakázky</span>
          </NavLink>
          <NavLink to="/mechanic/calendar" className={({ isActive }) => `btn btn-lg ${isActive ? 'btn-primary' : 'btn-outline-primary'}`}>
            <i className="bi bi-calendar-week me-2"></i>
            <span>Kalendář</span>
          </NavLink>
          <button type="button" className="btn btn-lg btn-secondary" onClick={handleLogout}>
            <i className="bi bi-box-arrow-right me-2"></i>
            <span>Odhlásit</span>
          </button>
        </div>

        <div className="d-flex align-items-center gap-2">
          <ColorMode className="btn btn-sm" />
          <Fullscreen className="btn btn-sm" />
          <UserInfo user={user} />
          <svg
            width="38"
            height="38"
            viewBox="3250 4000 14000 12000"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            className="text-body ms-1"
          >
            <path d="M8469.39 4560.02v3344.05l1836.83-1081.97 1836.83 1081.97V4560.02l-1836.83-1081.96-1836.83 1081.96zm1836.83 9195.12h1836.83v-500.87l-1836.83-1081.97-1836.83 1081.97v500.87h1836.83zm1836.83-4848v3344.05l-1836.83-1081.96-1836.83 1081.96V8907.14l1836.83-1081.96 1836.83 1081.96zM7617.87 8405.66V5061.62L5202.73 6484.23l-.03 3344.04zM7617.87 12752.78V9408.74l-2415.14 1422.61v1767.97c0 513.88 339.93 952.19 805.98 1101.32l1609.16-947.86zM6358.55 3478.06h1259.32v580.48L5202.73 5481.12v-847.24c0-635.7 520.12-1155.82 1155.82-1155.82zM12994.57 8405.66V5061.62l2415.14 1422.61.03 3344.04zM12994.57 12752.78V9408.74l2415.14 1422.61v1767.97c0 513.88-339.93 952.19-805.98 1101.32l-1609.16-947.86zM14253.89 3478.06h-1259.32v580.48l2415.14 1422.58v-847.24c0-635.7-520.12-1155.82-1155.82-1155.82z" />
          </svg>
        </div>
      </header>
      <main className="mechanic-main">
        <Outlet />
      </main>
    </div>
  )
}

export default LayoutMechanic
